export default __webpack_public_path__ + "static/oslo-mobile-4de143f2a053b57cdb59c794ba197a7f.png";